export const ENTITY_TYPES = {
  DAILY: 'daily',
  CONTENT: 'content',
};
